import {
  LeaderExtendQuery,
  NewRoleTypes,
  RoleTypes,
  StatusTypes,
} from 'configs/constants';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'configs';
import { normalizedPhoneNumber } from 'utils/helpers/helpers';

export enum ActiveUserSuccess {
  SUCCESS = 200,
}

export const ActiveUserSuccessDefined = {
  [ActiveUserSuccess.SUCCESS]: {
    message: 'Kích hoạt thành công',
  },
};

export enum InactiveUserSuccess {
  SUCCESS = 200,
}

export const InactiveUserSuccessDefined = {
  [InactiveUserSuccess.SUCCESS]: {
    message: 'Vô hiệu hóa thành công',
  },
};

export enum RemoveUserSuccess {
  SUCCESS = 200,
}

export const RemoveUserSuccessDefined = {
  [RemoveUserSuccess.SUCCESS]: {
    message: 'Xóa thành công',
  },
};
export type FilterType = {
  searchString?: string;
  isActive?: boolean | string;
  // role?: "Agency" | "Leader" | "SpVisor" | "Tất cả";
  role?: 'Agency' | 'SpVisor' | 'OilMc' | 'Admin' | 'Tất cả';
  searchDetailContent?: string;
  refreshData: number;
  pageSize: number;
  pageIndex: number;
};

export const getInitFilterValues = (urlParams: any): FilterType => {
  return {
    searchString: urlParams?.get('searchString') ?? '',
    isActive: urlParams?.get('isActive') ?? StatusTypes['Tất cả'],
    role: urlParams?.get('role') ?? RoleTypes['Tất cả'],
    searchDetailContent: urlParams?.get('searchDetailContent') ?? '',
    refreshData: 0,
    pageSize: Number(urlParams?.get('pageSize') ?? DEFAULT_PAGE_SIZE),
    pageIndex: Number(urlParams?.get('pageIndex') ?? DEFAULT_PAGE_INDEX),
  };
};

export const convertSelectLeaderOptions = (data: any[]) => {
  if (!data || !data.length) return [];

  const all = Object.keys(LeaderExtendQuery).map((key: string) => {
    return {
      label: LeaderExtendQuery[key as keyof typeof LeaderExtendQuery],
      value: key,
    };
  });

  const leaders = data?.map((item) => {
    return {
      label: `${item?.fullName}-${normalizedPhoneNumber(item?.phoneNumber as unknown as string)}`,
      value: `${item?.fullName}-${item?.phoneNumber}`,
    };
  });

  return [...all, ...leaders];
};

export const convertSelectRoleOptions = () => {
  return Object.keys(NewRoleTypes).map((key: string) => {
    return {
      label: key,
      value: NewRoleTypes[key as keyof typeof NewRoleTypes],
    };
  });
};

export const convertSelectStatusOptions = () => {
  return Object.keys(StatusTypes).map((key: string) => {
    return {
      label: key,
      value: StatusTypes[key as keyof typeof StatusTypes],
    };
  });
};

export const exportHeaders = [
  'STT',
  'Tài khoản',
  'Tên tài khoản',
  'CCCD/MST',
  'Tiểu khoản TPBank',
  'Mã đầu Tiểu khoản BIDV',
  'Tiểu khoản BIDV',
  'Hợp tác xã',
  // "Phòng ban",
  'Số dư (đ)',
  'Email',
  'Mã giới thiệu',
  'Trạng thái',
];

export const exportHeadersCreateMultiUser = [
  'STT',
  'Tài khoản',
  'Tên tài khoản',
  'CCCD/MST',
  'Tiểu khoản TPBank',
  'Tiểu khoản BIDV',
  'Email',
  'Vai trò',
  'Hợp tác xã',
  'Trạng thái',
];
